import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Redirect, useLocation } from 'react-router-dom';
import useIsLogged from '../hooks/useIsLogged';

const Landing = ({ loggedDefaultPathName, defaultPathName, externalRedirectPath }) => {
  const isLogged = useIsLogged();
  const location = useLocation();
  const shouldRedirectExternally = Boolean(
    externalRedirectPath,
  );

  useEffect(() => {
    if (shouldRedirectExternally) {
      window.location.replace(externalRedirectPath.trim());
    }
  }, [shouldRedirectExternally, externalRedirectPath]);

  if (isLogged) {
    return <Redirect to={loggedDefaultPathName} />;
  }
  if (shouldRedirectExternally) {
    return null;
  }
  return (
    <Redirect to={{
      pathname: defaultPathName,
      search: location.search,
    }}
    />
  );
};

Landing.propTypes = {
  loggedDefaultPathName: PropTypes.string,
  defaultPathName: PropTypes.string,
  externalRedirectPath: PropTypes.string,
};

Landing.defaultProps = {
  loggedDefaultPathName: '/app',
  defaultPathName: '/user-login',
  externalRedirectPath: null,
};

export default Landing;
